import { generateFileUrl } from '@app/common/utils/downloadFile/generateFileUrl';

export const downloadFile = (base64String: string, fileName: string, mimeType: string) => {
  const url = generateFileUrl(base64String, mimeType);
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link?.parentNode?.removeChild(link);
};
